/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_PAGE_CARTSERVICE = '/ext/cart';
const RESOURCE_PAGE_CARTSERIVE_EXT_PAGE = '/rewards/eligibility';

/**
 * getRewardElegilibity
 * url - /checkout/v2/cart-ext/rewards/eligibility'?brand={brandId}
 *
 * @param {Object} args
 * @param {String} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 */
const getRewardElegilibity = ({
    wcEnv, jwtToken, cartId, creditCard,
    isCardTokenized, sourceApp,
}) => {
    const envObj = wcEnv || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}`;

    const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}${RESOURCE_PAGE_CARTSERIVE_EXT_PAGE}`;
    const payload = {
        creditCard,
        cartId,
        isCardTokenized,
        sourceApp,
    };
    return restClient.postFacade(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default getRewardElegilibity;
